import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledSvg = styled.svg`
  position: relative;
  width: 100%;
  height: auto;
  bottom: 4%;
  left: -4%;

  .cls-1 {
    fill: ${({ $fill }) => $fill};
  }
`;

const Headshape = ({ fill }) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width="331.551"
      height="519.305"
      viewBox="0 0 331.551 519.305"
      $fill={fill}
    >
      <g id="head_3" data-name="head 3" transform="translate(-197.487 -153.157)">
        <g id="Group_476" data-name="Group 476">
          <g id="neck">
            <g id="Group_473" data-name="Group 473">
              <path
                id="Path_478"
                data-name="Path 478"
                className="cls-1"
                d="M333.5,668.583c117.833,27.467,134.245-99.994,129.291-99.165-20.354,3.4-19.417-5.647-19.417-5.647.363-17.707-1.169-47.345-.909-60.024s.515-22.616.733-29.386c.175-5.546.34-8.924.487-9.977-.173.462-.586,1.323-1.261,2.62-.487.933-1.1,2.082-1.838,3.426-.72,1.38-1.7,2.718-2.739,4.363l-1.679,2.557c-.607.863-1.284,1.692-1.974,2.6l-2.182,2.817c-.771.949-1.625,1.815-2.485,2.78a65.9,65.9,0,0,1-12.611,10.921,54.07,54.07,0,0,1-16.951,7.622,57.974,57.974,0,0,1-20.514,1.451l-2.757-.292-2.788-.47c-1.877-.264-3.757-.8-5.676-1.211a99.325,99.325,0,0,1-11.66-3.911,108.789,108.789,0,0,1-11.963-5.868q-3.02-1.713-6.053-3.707c-1-.651-2.057-1.384-3-2.05l-.246-.158q.068,4.752.136,9.623.134,7.566.345,15.319c.277,10.332-1.445,17.784-1.037,28.532s.3,17.922.848,29.008c.272,5.542-25.762,8.6-25.433,14.2C310.391,588.307,259.005,651.218,333.5,668.583Z"
              />
            </g>
            <g id="Group_474" data-name="Group 474">
              <path
                id="Path_479"
                data-name="Path 479"
                d="M444.55,564.477c-.345-6.849.415-25.966.45-28.955.267-23.025,1.036-48.258,1.185-71.284,0-.057-.012-.106-.015-.161s-.006-.091-.013-.135a2.223,2.223,0,0,0-1.7-1.98,2.272,2.272,0,0,0-2.732.749,2.231,2.231,0,0,0-.177.249c-.007.012-.016.02-.022.031-.025.044-.051.087-.076.13-.014.028-.033.051-.046.08-11.6,20.248-29.513,37.581-54.376,37.763-15.63.115-30.837-5.895-43.872-14.067a77.849,77.849,0,0,1-8.2-5.737,2.537,2.537,0,0,0-4.267,1.747c-.08,28.988.968,58.026,2.388,87l-.236.1c-.747.3-6.526,7.687-25.01,9.96A68.014,68.014,0,0,1,295,583.506c1.319.017,2.722.027,4.2-.043,2.029-.051,5.884-.364,8.88-.447,14.582-.408,24.6-9.057,25.184-9.341q.339,6.747.7,13.489c.355,6.664-.147,2.432.37,9.086a37.593,37.593,0,0,0,.544,5.548c1.721-3.938,3.129-17.1,2.422-30.929-1.785-34.925-1.539-47.881-1.59-82.864,22.186,16.342,53.738,24.536,78.879,10.806,11.045-6.032,19.653-15.346,26.543-25.68-.108,18.034.476,70.1.244,81.783.43,3.964-1.25,13.526,4.9,16A14.658,14.658,0,0,1,444.55,564.477Z"
              />
            </g>
          </g>
          <g id="Group_475" data-name="Group 475">
            <path
              id="Path_480"
              data-name="Path 480"
              className="cls-1"
              d="M359.877,534.826h0a70.737,70.737,0,0,1-30.166-.431q-1.059-.255-2.113-.544l-60.23-16.486c-26.946-8.012-56.523-46.931-61.023-81.118C196.131,358.654,199,305.318,203.954,272.33c4.8-31.981,20.887-61.233,45.992-81.618,19.31-15.68,34.534-24.559,50.067-29.787a114.578,114.578,0,0,1,41.173-5.667l40.569,1.635h0c12.41,1.456,26.085,3.468,34.744,5.341,33.089,7.158,63.431,25.51,84.669,55.908,20.639,29.541,29.1,65.907,24.753,101.681L510.714,445.054c-8.8,27.375-51.965,58.506-80.075,68.752C401.386,524.47,359.209,535.861,359.877,534.826Z"
            />
            <path
              id="Path_481"
              data-name="Path 481"
              d="M345.5,538.252a69.129,69.129,0,0,1-16.255-1.912c-.727-.176-1.451-.361-2.172-.56l-60.23-16.486c-28.115-8.359-57.874-47.813-62.478-82.786-10.455-79.427-7.068-133.283-2.385-164.475,4.954-33.008,21.542-62.439,46.708-82.874,19.01-15.436,34.643-24.728,50.69-30.129a116.261,116.261,0,0,1,41.892-5.771l40.721,1.647c13.822,1.623,26.881,3.632,34.934,5.374,35.65,7.711,65.349,27.324,85.886,56.717,20.665,29.578,29.578,66.181,25.1,103.067l-15.229,125.42-.059.182c-4.1,12.765-15.981,27.589-33.442,41.741-15.213,12.33-33.1,22.9-47.852,28.279-12.351,4.5-29.164,9.883-46.126,14.765-16.638,4.787-22.6,6.246-25.006,6.352A76.858,76.858,0,0,1,345.5,538.252Zm-9.347-381.1a110.927,110.927,0,0,0-35.5,5.665c-15.573,5.242-30.823,14.322-49.444,29.443-24.39,19.8-40.469,48.344-45.274,80.362-4.645,30.939-8,84.394,2.4,163.36,4.347,33.027,33.317,71.644,59.61,79.462l60.188,16.475q1.026.279,2.056.528a68.207,68.207,0,0,0,29.311.412l4.611-.9-.062.1c11.254-2.716,42.5-11.6,65.913-20.129,26.976-9.834,69.923-40.164,78.8-67.307l15.184-125.039c4.36-35.907-4.308-71.525-24.408-100.294-19.948-28.551-48.805-47.6-83.452-55.1-7.921-1.713-20.8-3.694-34.478-5.3l-40.493-1.632Q338.617,157.155,336.15,157.156Z"
            />
          </g>
        </g>
      </g>
    </StyledSvg>
  );
};

Headshape.propTypes = {
  fill: PropTypes.string
};

export default React.memo(
  Headshape,
  (prevProps, nextProps) => prevProps.fill === nextProps.fill
);
